<template>
  <div class="wrapper">
    <div class="header">
      <div class="logo">
        <AEyeLogo />
      </div>
    </div>
    <div class="body">
      <div class="content">
        <ts-page class="page">
          <div class="w-full px-7 py-5 rounded-full shadow-lg bg-gradient-gray-500 page-header">
            <h1 class="mb-2 font-normal text-lg leading-sm title" style="color: #000;">
              <span class="font-semibold" v-text="fileRequest.creator.name"></span> sent you this
              {{ isDeliveryFileRequest ? 'Delivery ' : '' }}
              File Request
            </h1>
            <p class="leading-loose text-gray-500 text-md subtitle">
              For <span class="font-semibold" v-text="fileRequest.project.name"></span> with <span class="font-semibold" v-text="projectBrandNames"></span>
            </p>
          </div>
          <div class="page-content page-content-with-topbar">
            <div class="content-wrapper">
              <div class="container px-14">
                <AlertInfoBox message="Simply drag & drop assets in the dedicated areas, and submit them with the green button. Thank you! "/>
                <div class="mb-10">
                  <h1 class="font-normal text-2xl text-gray-500 mb-2 content-title" v-text="fileRequest.name"></h1>
                  <AlertCommentBox v-if="fileRequest.description" :message="fileRequest.description"/>
                </div>
                <div class="upload-container mt-4 w-full mb-10 mx-auto w-full" v-if="fileRequest.id">
                  <template v-if="isDeliveryFileRequest">
                    <div class="grid grid-cols-2 gap-10">
                      <div class="">
                        <file-request-uploader
                          style="height: 100%"
                          :resumable="resumable"
                          :files="finalAssets"
                          group="deliverables"
                          label="Final Assets"
                          @added="handleAddFinalAssets"
                          @removed="handleRemoveFinalAssets"
                        />
                      </div>
                      <div class="">
                        <file-request-uploader
                          style="height: 100%"
                          :resumable="resumable"
                          :files="workingFiles"
                          label="Working Files"
                          group="working_files"
                          @added="handleAddWorkingFiles"
                          @removed="handleRemoveWorkingFiles"
                        />
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="">
                      <file-request-uploader
                        :resumable="resumable"
                        :files="campaignAssets"
                        group="campaign-assets"
                        @added="handleAddCampaignAssets"
                        @removed="handleRemoveCampaignAssets"
                      />
                    </div>
                  </template>
                  <!-- <file-request-uploader
          :files="brandIdentityAssets"
          :resumable="resumable"
          label="Brand Identity"
          group="brand-identity"
          @added="handleAddBrandIdentityAssets"
          @removed="handleRemoveBrandIdentityAssets"
        /> -->
                </div>
                <div class="flex items-center justify-center" v-if="hasAssets">
                  <ts-button type="primary" size="medium" :loading="loading" filled @click.prevent="uploadAssets">
                    Upload
                  </ts-button>
                </div>
                <div class="fixed flex items-center justify-center inset-0" v-if="loading">
                  <span class="inset-0 absolute opacity-25 bg-gradient-gray-500"></span>
                  <div class="relative">
                    <ts-loader></ts-loader>
                  </div>
                </div>
              </div>
              <ts-dialog :visible.sync="uploaded">
                <div class="w-full max-w-lg mx-auto text-center mb-4">
                  <h1 class="border-b border-gray-600 text-center py-2 mb-4 font-normal">
                    Your files have been uploaded
                  </h1>
                  <p class="mb-6 text-base text-center">
                    We will let <span class="font-semibold" v-text="fileRequest.creator.name"></span> know that you have
                    uploaded files
                  </p>
                  <ts-button @click="addAnotherFiles" size="medium"> Add other files </ts-button>
                </div>
              </ts-dialog>
            </div>
          </div>
          <slot name="bottombar"></slot>
          <download-succes-dialog></download-succes-dialog>
        </ts-page>
      </div>
    </div>
  </div>
</template>

<script>
import AEyeLogo from '@/assets/ai-eye.svg';
import projectViewHelpers from '@/mixins/projectViewHelpers';
import uploader from '@/mixins/uploader';
import FileRequestUploader from './FileRequestUploader.vue';
import DownloadSuccesDialog from '@/components/widgets/DownloadSuccesDialog.vue';
import { createUploadRecord, updateUploadRecord } from '@/api/workflow';

import AlertInfoBox from "@/components/widgets/AlertInfoBox.vue";
import AlertCommentBox from "@/components/widgets/AlertCommentBox.vue";
export default {
  mixins: [projectViewHelpers, uploader],
  components: {
    FileRequestUploader,
    DownloadSuccesDialog,
    AlertInfoBox,
    AlertCommentBox,
    AEyeLogo
  },
  data() {
    return {
      uploaded: false,
      campaignAssets: [],
      finalAssets: [],
      workingFiles: [],
      brandIdentityAssets: [],
      uploadedAssets: {
        finalAssets: {},
        workingFiles: {}
      },
      skeleton: {
        project: {
          brands: []
        },
        creator: {},
        group: null
      }
    };
  },
  methods: {
    addAnotherFiles() {
      this.uploaded = false;
    },
    async uploadAssetsUsingFileRequest(payload) {
      return await this.$store.dispatch('workflow/fileRequests/uploadAsset', payload);
    },
    handleRemoveWorkingFiles(asset) {
      this.workingFiles = this.workingFiles.filter(item => {
        return asset.resumableFile.uniqueIdentifier !== item.resumableFile.uniqueIdentifier;
      });

      this.resumable.removeFile(asset.resumableFile);
    },
    handleRemoveFinalAssets(asset) {
      this.finalAssets = this.finalAssets.filter(item => {
        return asset.resumableFile.uniqueIdentifier !== item.resumableFile.uniqueIdentifier;
      });

      this.resumable.removeFile(asset.resumableFile);
    },
    handleRemoveCampaignAssets(asset) {
      this.campaignAssets = this.campaignAssets.filter(item => {
        return asset.resumableFile.uniqueIdentifier !== item.resumableFile.uniqueIdentifier;
      });

      this.resumable.removeFile(asset.resumableFile);
    },
    handleRemoveBrandIdentityAssets(asset) {
      this.brandIdentityAssets = this.brandIdentityAssets.filter(item => {
        return asset.resumableFile.uniqueIdentifier !== item.resumableFile.uniqueIdentifier;
      });

      this.resumable.removeFile(asset.resumableFile);
    },
    handleAddCampaignAssets(asset) {
      this.campaignAssets.push(asset);
    },
    handleAddFinalAssets(asset) {
      this.finalAssets.push(asset);
    },
    handleAddWorkingFiles(asset) {
      this.workingFiles.push(asset);
    },
    handleAddBrandIdentityAssets(asset) {
      this.brandIdentityAssets.push(asset);
    },
    async uploadAssets() {
      if (!this.hasAssets) {
        return;
      }

      if (!this.isDeliveryFileRequest) {
        this.startUpload = await createUploadRecord({
          projectId: this.$route.params.projectId,
          assetRequestId: this.fileRequest.id
        });
      }

      this.resumable.upload();
    },
    handleFileError(file, message) {
      const asset = this.mergedAssets.find(a => a.resumableFile.uniqueIdentifier == file.uniqueIdentifier);
      if (asset) {
        console.error('Server error when adding asset', message);
        asset.uploadError = true;
        asset.uploadErrorMessage = message;
        this.showError('Error when adding asset');
      }
    },
    uploading(id, uploading) {
      let keys = ['campaignAssets', 'brandIdentityAssets', 'finalAssets', 'workingFiles'];

      keys.forEach(key => {
        this[key] = this[key].map(u => {
          if (u.resumableFile.uniqueIdentifier !== id) {
            return u;
          }

          u.uploading = uploading;

          return u;
        });
      });
    },
    isLastUpload() {
      return this.mergedAssets.filter(u => !u.uploading).length === 0;
    },
    async createAssetFromUploadedFile(file) {
      const asset = this.mergedAssets.find(a => a.resumableFile.uniqueIdentifier == file.uniqueIdentifier);
      if (asset) {
        try {
          if (asset.group === 'working_files') {
            this.uploadedAssets.workingFiles[file.uniqueIdentifier] = true;
          } else if (asset.group === 'deliverables') {
            this.uploadedAssets.finalAssets[file.uniqueIdentifier] = true;
          }
          this.uploading(file.uniqueIdentifier, true);
          let payload = { asset };
          if (this.isLastUpload()) {
            payload.lastUpload = true;
            payload.finalAssets = Object.keys(this.uploadedAssets.finalAssets).length > 0;
            payload.workingFiles = Object.keys(this.uploadedAssets.workingFiles).length > 0;
          }
          const createdAsset = await this.uploadAssetsUsingFileRequest(payload);

          if (!this.isDeliveryFileRequest) {
            this.startUpload.assets.push(createdAsset.id);
          }
          this.showInfo(`Asset ${asset.name} created.`);

          if (asset.group === 'campaign-assets') {
            this.campaignAssets = this.campaignAssets.filter(
              a => a.resumableFile.uniqueIdentifier !== file.uniqueIdentifier
            );
          } else if (asset.group === 'working_files') {
            this.workingFiles = this.workingFiles.filter(
              a => a.resumableFile.uniqueIdentifier !== file.uniqueIdentifier
            );
            this.uploadedAssets.workingFiles[file.uniqueIdentifier] = true;
          } else if (asset.group === 'deliverables') {
            this.finalAssets = this.finalAssets.filter(a => a.resumableFile.uniqueIdentifier !== file.uniqueIdentifier);
            this.uploadedAssets.finalAssets[file.uniqueIdentifier] = true;
          } else {
            this.brandIdentityAssets = this.brandIdentityAssets.filter(
              a => a.resumableFile.uniqueIdentifier !== file.uniqueIdentifier
            );
          }

          if (this.mergedAssets.length === 0) {
            if (!this.isDeliveryFileRequest) {
              updateUploadRecord(this.startUpload);
            }
            this.currentUpload = null;
            this.uploaded = true;
            Object.keys(this.uploadedAssets).forEach(key => (this.uploadedAssets[key] = {}));
          }
        } catch (err) {
          console.error('Server error when adding asset', err);
          this.showError('Error when adding asset');
          this.uploading(file.uniqueIdentifier, false);
          delete this.uploadedAssets.finalAssets[file.uniqueIdentifier];
          delete this.uploadedAssets.workingFiles[file.uniqueIdentifier];
        }
      }
    }
  },
  computed: {
    projectBrandNames() {
      return this.fileRequest.project.brands.map(b => b.name).join(', ');
    },
    isDeliveryFileRequest() {
      return this.fileRequest && this.fileRequest.group == 'delivery';
    },
    uploadableFiles() {
      return this.mergedAssets.map(asset => asset.resumableFile);
    },
    mergedAssets() {
      return [...this.campaignAssets, ...this.brandIdentityAssets, ...this.finalAssets, ...this.workingFiles];
    },
    fileRequest() {
      return this.$store.state.workflow.fileRequests.fileRequest.value || this.skeleton;
    },
    error() {
      return this.$store.state.workflow.fileRequests.fileRequest.error;
    },
    loading() {
      return this.$store.state.workflow.fileRequests.fileRequest.loading;
    },
    hasAssets() {
      return this.mergedAssets.length > 0;
    }
  },
  watch: {
    error(value) {
      if (value) {
        this.showError('File request missing or repired.');
        this.$router.push('/');
      }
    }
  },
  mounted() {
    this.resumable.on('fileSuccess', file => {
      this.createAssetFromUploadedFile(file);
    });

    this.resumable.on('fileError', (file, message) => {
      this.handleFileError(file, message);
    });

    this.$store.dispatch('workflow/fileRequests/fetchProjectFileRequest', {
      projectId: this.$route.params.projectId,
      token: this.$route.params.token
    });
  }
};
</script>

<style scoped lang="scss">
:root {
  --fills-neutral-grey-dark: red;
}
.wrapper {
  max-width: 1300px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  .header {
    height: 80px;
    padding-top: 10px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;

    .logo {
      display: flex;
      width: 183px;
      align-items: center;
      justify-content: center;
    }
  }

  .loader {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgba(235, 236, 240, 0.8);
  }

  .body {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .topbar {
    height: 76px;
    border-radius: 38px;
    background: #ebecf0;
    box-shadow: 6px 6px 16px 0 rgba(166, 171, 189, 0.4), -6px -6px 16px 0 rgba(250, 251, 255, 0.4);
    border: solid 2px rgba(255, 255, 255, 0.32);
    background-blend-mode: soft-light, normal;
    background-image: linear-gradient(274deg, #000000, var(--fills-neutral-white) 0%),
      linear-gradient(to bottom, #ebecf0, #ebecf0);
    position: relative;
  }

  .content {
    // display: flex;
    // height: calc(100vh - 80px - 10px);
    position: relative;
    .container {
      margin-bottom: 30px;
      padding: 10px 3rem;
    }

    .page-header {
      height: 76px;
      border-radius: 38px;
      box-shadow: 6px 6px 16px 0 rgba(166, 171, 189, 0.4), -6px -6px 16px 0 rgba(250, 251, 255, 0.4);
      border: solid 2px rgba(255, 255, 255, 0.32);
      background-blend-mode: soft-light, normal;
      background-image: linear-gradient(275deg, #000, rgba(255, 255, 255, 0.32) 0%),
        linear-gradient(to bottom, #ebecf0, #ebecf0);
      .title {
        font-family: Roboto;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.7;
        letter-spacing: normal;
        color: #6d7587;
      }

      .subtitle {
        font-family: Roboto;
        font-size: 12px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
        color: #6d7587;
      }
    }

    .content-title {
      font-family: Roboto;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 0.7;
      letter-spacing: normal;
      color: #6d7587;
    }

    .content-subtitle {
      font-family: Roboto;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      color: #6d7587;
    }

    .page {
      flex-grow: 1;
      position: relative;

      .account-selector {
        position: absolute;
        right: -95px;
        top: 45px;
        z-index: 0;
      }

      .page-content {
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: scroll;
      }

      .page-content-with-topbar {
        padding-top: 38px;
      }

      .page-overlay {
        background-color: rgba(235, 236, 240, 0.6);
        transition: background-color 0.5s;
        border-radius: 32px;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        z-index: 2;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
.content {
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
}
.upload-container {
}
.border-b {
  border-bottom-style: solid;
  border-bottom-width: 2px;
}
.border-gray-600 {
  border-color: #dbe2ea;
}
.font-normal {
  font-weight: normal;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.inset-0 {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.h-full {
  height: 100%;
}
.w-full {
  width: 100%;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.fixed {
  position: fixed;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.px-14 {
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.pt-20 {
  padding-top: 8.5rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.opacity-25 {
  opacity: 0.75;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.w-full {
  width: 100%;
}
.rounded-full {
  border-radius: 30px;
}
.rounded-md {
  border-radius: 10px;
}
.shadow-lg {
  box-shadow: 6px 6px 16px 0 rgba(166, 171, 189, 0.4), -6px -6px 16px 0 rgba(250, 251, 255, 0.4);
}
.shadow-md {
  box-shadow: 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
}
.bg-gradient-gray-500 {
  background-blend-mode: soft-light, normal;
  background-image: linear-gradient(275deg, #000000, white 0%), linear-gradient(to bottom, #ebecf0, #ebecf0);
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.font-semibold {
  font-weight: 500;
}
.font-normal {
  font-weight: normal;
}
.text-base {
  font-size: 1rem;
}
.text-lg {
  font-size: 1.25rem;
}
.text-2xl {
  font-size: 1.75rem;
}
.leading-sm {
  line-height: 0.7;
}
.leading-loose {
  line-height: 1.5;
}
.text-md {
  font-size: 0.75rem;
}
.text-gray-500 {
  color: var(--fills-neutral-grey-dark);
}
.flex {
  display: flex;
}
.flex-col {
  flex-direction: column;
}
.justify-center {
  justify-content: center;
}
.items-center {
  align-items: center;
}
.mb-2 {
  margin-bottom: 0.5em;
}
.mt-4 {
  margin-top: 1rem;
}
.flex-1 {
  flex: auto;
}
.flex-none {
  flex: none;
}
.px-2 {
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.py-2 {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}
.justify-between {
  justify-content: space-between;
}
.justify-center {
  justify-content: center;
}
.cursor-pointer {
  cursor: pointer;
}
.grid {
  display: grid;
}
.grid-cols-2 {
  grid-template-columns: 1fr 1fr;
}
.grid-cols-gap-6 {
  column-gap: 1.5rem;
}
.text-center {
  text-align: center;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.border-1 {
  border: solid 2px rgba(255, 255, 255, 0.16);
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-span-4 {
  grid-column: span 4 / span 4;
}
.col-span-5 {
  grid-column: span 5 / span 5;
}
.gap-0 {
  gap: 0px;
}
.gap-x-0 {
  column-gap: 0px;
}
.gap-y-0 {
  row-gap: 0px;
}
.gap-px {
  gap: 1px;
}
.gap-x-px {
  column-gap: 1px;
}
.gap-y-px {
  row-gap: 1px;
}
.gap-10 {
  gap: 3.125rem;
}
.gap-5 {
  gap: 1.125rem;
}
.gap-x-5 {
  column-gap: 1.125rem;
}
.gap-y-5 {
  row-gap: 1.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-x-1 {
  column-gap: 0.25rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.grid {
  display: grid;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}
.grid-cols-9 {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}
.grid-cols-10 {
  grid-template-columns: repeat(10, minmax(0, 1fr));
}
.grid-cols-11 {
  grid-template-columns: repeat(11, minmax(0, 1fr));
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-none {
  grid-template-columns: none;
}
</style>